import React from 'react';
import './Step6Review.css';
import AutomationNameAndDescriptionFields from './AutomationNameAndDescriptionFields';
import { scheduleLabel } from '../../../../utils/scheduleLabel';
import { defaultScheduleZone } from '../../shared/ScheduleZoneField';

const Step6Review = ({ formData, onSetFormData, onCreate }) => {
  const formatTrigger = () => scheduleLabel(formData.trigger, formData.timezone || defaultScheduleZone());

  return (
    <div className="step-content">
      <h3 className="step-title">Review and create</h3>

      <div className="review-section">
        <div className="review-item">
          <span className="review-label">Type:</span>
          <span className="review-value">{formData.type.charAt(0).toUpperCase() + formData.type.slice(1)}</span>
        </div>
        <div className="review-item">
          <span className="review-label">Sources:</span>
          <span className="review-value">{formData.source?.name || 'N/A'}</span>
        </div>
      </div>

      <div className="review-section">
        <div className="review-section-title">Ingestion settings</div>
        <div className="review-item">
          <span className="review-label">Source:</span>
          <span className="review-value">{formData.source?.name || 'N/A'}</span>
        </div>
        <div className="review-item">
          <span className="review-label">File types:</span>
          <span className="review-value">
            {formData.ingestionSettings.fileTypes.length > 0
              ? formData.ingestionSettings.fileTypes.map(t => t.toUpperCase()).join(', ')
              : 'None'}
          </span>
        </div>
        <div className="review-item">
          <span className="review-label">Path prefix:</span>
          <span className="review-value">{formData.ingestionSettings.pathPrefix || 'None'}</span>
        </div>
        <div className="review-item">
          <span className="review-label">Filename pattern:</span>
          <span className="review-value">{formData.ingestionSettings.filenamePattern || 'None'}</span>
        </div>
        <div className="review-item">
          <span className="review-label">Dedupe strategy:</span>
          <span className="review-value">
            {formData.ingestionSettings.dedupeStrategy === 'by-path'
              ? 'Skip files already processed (by path)'
              : formData.ingestionSettings.dedupeStrategy === 'by-path-modified'
              ? 'Skip by (path + last modified)'
              : 'Reprocess everything each run'}
          </span>
        </div>
        <div className="review-item">
          <span className="review-label">Ingestion mode:</span>
          <span className="review-value">
            {formData.ingestionSettings.ingestionMode === 'append'
              ? 'Append new files to existing dataset'
              : formData.ingestionSettings.ingestionMode === 'replace'
              ? 'Replace dataset each run (full rebuild)'
              : formData.ingestionSettings.ingestionMode === 'new-dataset'
              ? 'Create a new dataset per run'
              : 'Create a new dataset per new folder/prefix'}
          </span>
        </div>
      </div>

      <div className="review-section">
        <div className="review-item">
          <span className="review-label">Trigger:</span>
          <span className="review-value">{formatTrigger()}</span>
        </div>
      </div>

      <div className="review-section">
        <div className="review-section-title">Destinations</div>
        {formData.destinations.map((dest, index) => (
          <div key={index} className="review-item">
            <span className="review-value">
              {dest.kind === 'internal-dataset' ? 'Internal dataset' : dest.kind} → "{dest.targetName || '(empty)'}" on ResAI internal storage
            </span>
          </div>
        ))}
      </div>

      <AutomationNameAndDescriptionFields formData={formData} onSetFormData={onSetFormData} />
    </div>
  );
};

export default Step6Review;
